import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef, Input , EventEmitter, Output} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../services/notification.service';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { PrintService } from '../../services/print.service';
import { ExportService } from '../../services/exporter.service';
import { FileExport } from '../../model/exporter.model';
import { saveAs } from 'file-saver';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

//Service
import { JobNoticationsService } from '../../services/jobnotifications.service';
import { DataService } from '../../services/data.service';
import  *  as  helpData  from  '../../data/help/jobs_notifications.json';
import { ComponentsSettingsService} from './../../services/components_settings.service';

//Model
import { JobNotification } from '../../model/jobnotification.model';
import { ThemeSetting } from 'src/app/model/users.model';
import * as moment from 'moment';

@Component({
    selector: 'app-jobnotifications',
    templateUrl: './jobnotifications.component.html',
    styleUrls: ['./jobnotifications.component.scss', '../datatable.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [ JobNoticationsService ],
})
  
export class JobNotificationsComponent implements OnInit {
  	
  public s_theme: ThemeSetting;
  public jobnotifications : any [];
  public full_rows_jnotifications : any [];
  public selected : any []=[];
  public loadingIndicator: boolean = true;
  public count : number = 0;
  public showFilters: boolean = false;

  public categories: any[];
  public drivers: any[];
  public controlNos: any[];
  public activities: any[];

  columns = [
    { prop: 'id' },
    { prop: 'categories_id' },
    { prop: 'customer_id' },
    { prop: 'job_id' },
    { prop: 'driver_id' },
    { prop: 'fleet_id' },
    { prop: 'activity_type_id' },
    { prop: 'link' },
    { prop: 'text' },
    { prop: 'category_name' },
    { prop: 'customer_name' },
    { prop: 'company_name' },
    { prop: 'job_control_no' },
    { prop: 'driver_full_name' },
    { prop: 'driver_email' },
    { prop: 'fleet_model' },
    { prop: 'activity_name' },
    { prop: 'created_at' },
  ];

  public c_category : boolean = true;
  public c_date: boolean = true;        
  public c_driver: boolean = true;
  public c_manifest_ctrl_no: boolean = true;    
  public c_activity: boolean = true;          
  public c_details: boolean = true;
  
  //Handles the name, type and content of the to-be exported file
  public exp_excel: FileExport;
  public exp_pdf: FileExport;

  //Stores the filtered and formatted content of the file
  formatted_list: any;

  public select_category: string = 'All';
  public select_driver: string = '';
  public select_ctrl_no: string = '';
  public select_activity: string = 'All';
  public select_details: string = '';

  isFilterEmpty: boolean = true;
  temp_jobnotifications = [];
  
  help: any;
  public current_user :number;
  private uploadPath: string;

  public frmDate: FormGroup;
  public modalRef: NgbModalRef;
  public setFilter: boolean;

  public dateLessThan(from: string, to: string) {
    return (group: FormGroup): { [key: string]: any } => {
      let f = group.controls[from];
      let t = group.controls[to];
      if (f.value > t.value) {
        return {
          dates: "Start date should be less than or equal to End date. Enter valid date."
        };
      }
      return {};
    }
  }

  constructor(private http: HttpClient, 
        private _fb: FormBuilder, 
        private svc_jnotif: JobNoticationsService,
        private toastr: NotificationService,
        private svc_storage: LocalStorageService,
        private router : Router,
        public printer: PrintService,
        private exporter: ExportService,
        private data: DataService,
        public modalService: NgbModal,
        private svc_components : ComponentsSettingsService
  ){

    this.frmDate = this._fb.group({
      start_date: ['', Validators.required],
      end_date: ['', Validators.required],
    }, { validator: this.dateLessThan('start_date', 'end_date') });

    this.setFilter = true;
  }

  ngOnInit() {
      this.s_theme = this.svc_storage.get('themeSettings');
      this.current_user = this.svc_storage.get('user').id;
      this.data.currentHelp.subscribe(help => this.help = help);

      
      //Declaration to handle the name, type and content of the file
      this.exp_excel = { title: '', list_data: '', type: '' };
      this.exp_pdf = { title: '', list_data: '', type: '' };
      
      this.uploadPath = this.svc_storage.get('url').fileStorage;

      this.getJobCategories();
      //this.getDrivers();
      this.getJobNotifications();
      //this.getControlNos();
      this.getActivities();
  }

  ngAfterViewInit() {
      setTimeout(() => { 	this.data.changeHelp(helpData["default"]);  });
  }

  getJobNotifications() {
    this.loadingIndicator = true;

    this.svc_jnotif.getJobNotifications().subscribe(data => {
      this.jobnotifications = data["jobnotifications"];
      this.full_rows_jnotifications = data["jobnotifications"];
      if(this.jobnotifications.length){
        this.selected = [data["jobnotifications"][0]]; 
        this.count = this.jobnotifications.length;
      }
      
      if(this.jobnotifications.length > 0){
        this.jobnotifications.forEach(row=>{
          row.render_details = this.renderHtml(row);
        });
      }
      
      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    });
  }

  async getJobCategories() {
    await this.svc_jnotif.getJobCategories().toPromise().then(data => {
      this.categories = data["jobcategories"];
      this.categories.push({ category_name: 'All' });
    });
  }

  // async getDrivers() {
  //   await this.svc_jnotif.getDriversByNotifications().toPromise().then(data => {
  //     this.drivers = data["drivers"];
  //     this.drivers.push({ driver_full_name: 'All' });
  //     this.drivers.push({ driver_full_name: 'No Assigned Driver' });

  //     var index = this.drivers.findIndex(item => item.driver_full_name === null);
  //     this.drivers.splice(index, 1);
  //   });
  // }

  // async getControlNos() {
  //   await this.svc_jnotif.getJobControlNos().toPromise().then(data => {
  //     this.controlNos = data["jobcontrolno"];
  //     this.controlNos.push({ control_no: 'All' });
  //     this.controlNos.push({ control_no: 'No Assigned Control No' });

  //     var index = this.controlNos.findIndex(item => item.control_no === null);
  //     this.controlNos.splice(index, 1);
  //   });
  // }

  async getActivities() {
    await this.svc_jnotif.getActivities().toPromise().then(data => {
      this.activities = data["activities"];
      this.activities.push({ activity_name: 'All' });
      this.activities.push({ activity_name: 'No Activity Type' });

      var index = this.activities.findIndex(item => item.activity_name === null);
      this.activities.splice(index, 1);
    });
  }
  
  public formatDate(inDate: string) {
      let formatedDate: Date;
      if (inDate && !inDate.includes('0000') ) {
        formatedDate = new Date(inDate.replace(/-/g, "/"));
        return formatedDate;
      }
      else return null;
  }


    //Formats readable header names in the given table
  generateHeaders(jobnotifications): any {
      const arr = JSON.parse(jobnotifications);
      arr.forEach(obj => {
          this.exporter.renameKey(obj, 'category_name', 'Category');
          this.exporter.renameKey(obj, 'created_at', 'Date');
          this.exporter.renameKey(obj, 'driver_full_name', 'Driver');
          this.exporter.renameKey(obj, 'job_control_no', 'Connote Control No.');
          this.exporter.renameKey(obj, 'activity_name', 'Activity');
          this.exporter.renameKey(obj, 'text', 'Details');
        });
      const updatedJson = JSON.stringify(arr);
      return updatedJson;
  }

  //Filters every column in the table list
  generateColumnsWithFilter(jobnotifications) {
      const arr = JSON.parse(JSON.stringify(jobnotifications));
      arr.forEach(obj => {

        obj['created_at'] = formatDate(obj['created_at'], 'dd MMM yyyy', 'en_US');


          if(!this.c_category){
              delete obj['category_name'];
          };
          if(!this.c_date){
              delete obj['created_at'];
          };     
          if(!this.c_driver){
              delete obj['driver_name'];
          };
          if(!this.c_manifest_ctrl_no){
              delete obj['job_control_no'];
          };
          if(!this.c_activity){
              delete obj['activity_name'];
          };
          if(!this.c_details){
              delete obj['text'];
          };
          
          // //remove filtered columns
          delete obj['id'];
          delete obj['categories_id'];
          delete obj['customer_id'];
          delete obj['job_id'];
          delete obj['driver_id'];
          delete obj['fleet_id'];
          delete obj['activity_type_id'];
          delete obj['link'];
          delete obj['customer_name'];
          delete obj['driver_email'];
          delete obj['fleet_model'];
          delete obj['updated_at'];
          delete obj['company_name'];
          delete obj['render_details'];
      });

      
      const updatedJson = JSON.stringify(arr);
      return updatedJson;
  }

    //Exports  table to CSV file
  exportToCSV() {
      if (this.jobnotifications.length > 0) {
          let with_header_format, with_column_filter;

          //generate json with filtered column
          with_column_filter = this.generateColumnsWithFilter(this.jobnotifications);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Activities_' + this.formattedDate(current_date);
              this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Activities');
      }
  };

  //Exports table to PDF file
  exportToPDF() {
      if (this.jobnotifications.length > 0) {
          let with_header_format, with_column_filter, pdf_file;

          //generate json with filtered column
          with_column_filter = this.generateColumnsWithFilter(this.jobnotifications);

          //generate json with format header
          this.formatted_list = this.generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          pdf_file = '[TMS]Activities_' + this.formattedDate(current_date);
              this.exp_pdf.title = 'TMS Bills';
          
          this.exp_pdf.type = 'pdf';
          this.exp_pdf.list_data = this.formatted_list;
          this.exporter.exportToPDF(this.exp_pdf).subscribe(data => {
              saveAs(data, pdf_file + '.' + this.exp_pdf.type);
          });
      }
  };

  //Exports table to MS Excel file
  exportToExcel() {
      if (this.jobnotifications.length > 0) {
      let with_header_format, with_column_filter, excel_file;

      //generate json with filtered column
      with_column_filter = this.generateColumnsWithFilter(this.jobnotifications);

      //generate json with format header
      this.formatted_list = this.generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();
      excel_file = '[TMS]Activities_' + this.formattedDate(current_date);
          this.exp_excel.title = 'TMS Activities';

          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data => {
              saveAs(data, excel_file)
          });
      }
  };

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
      let month = String(d.getMonth() + 1);
      let day = String(d.getDate());
      const year = String(d.getFullYear());

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return `${day}/${month}/${year}`;
  }

  public renderHtml(notification: JobNotification) {
    var html = notification.text;
    if (notification.job_id != null) {
      html = html.replace(new RegExp(notification.job_control_no), match => {
        if(this.isEnabled('Jobs') || this.isEnabled('Connotes')){
          return '<a class="link" title="View Job" href="bookings/connotes/details/' + notification.job_id + '">' + match + '</a>';
        }else{
          return match;
        }
      });
    }

    if (notification.driver_id != null) {
      html = html.replace(new RegExp(notification.driver_full_name), match => {
        if(this.isEnabled('Drivers')){
          return '<a class="link" title="View Driver" href="drivers/driverslist/driverdetails/' + notification.driver_id + '">' + match + '</a>';
        }else{
          return match;
        }
      });
    }

    if (notification.link != null) {

      //checks if there is no match key and also no job_id and driver_id present in the notification.text. If true, puts the whole text as link to the document. 
      //else it only makes the keywords the activated link.

      var matched = html.match(/(file|Report|Repair|Refueled)/)

      if (matched == null && notification.job_id == null && notification.driver_id == null) {
        html = '<a class="link" title="View Document" target="_blank" href="' + this.uploadPath + '/' + notification.link + '">' + notification.text + '</a>'
      }
      else {
        html = html.replace(new RegExp("file|Report|Repair|Refueled"), match => {
          return '<a class="link" title="View Document" target="_blank" href="' + this.uploadPath + '/' + notification.link + '">' + match + '</a>'
        });
      }

    }

    return html;
  }

  public toggleFilters() {
    if (this.showFilters) this.showFilters = false;
    else this.showFilters = true;
  }

  updateFilter() {
    console.log('filtering..');
    this.isFilterEmpty = false;
    this.temp_jobnotifications = this.full_rows_jnotifications;

    if (this.select_category) {
      this.temp_jobnotifications = this.full_rows_jnotifications.filter(data => {
        if (this.select_category == 'All') {
          return data;
        } else {
          if (this.select_category && data.category_name) {
            return data.category_name.toLowerCase().indexOf(this.select_category.toLowerCase()) !== -1 || !this.select_category.toLowerCase();
          } else {
            return data.category_name;
          }
        };
      });
    }

    if (this.start_date && this.end_date) {
        this.temp_jobnotifications = this.temp_jobnotifications.filter(data => {
          if (this.start_date && this.end_date &&  data.created_at) {
            return moment(data.created_at).format('YYYY-MM-DD') >= this.start_date &&  moment(data.created_at).format('YYYY-MM-DD') <= this.end_date
          } else {
            return data.created_at;
          }
        });
    }

    if (this.select_driver) {
        this.temp_jobnotifications = this.temp_jobnotifications.filter(data => {
          if (this.select_driver && data.driver_full_name) {
            return data.driver_full_name.toLowerCase().indexOf(this.select_driver.toLowerCase()) !== -1 || !this.select_driver.toLowerCase();
          } else {
            return data.driver_full_name;
          }
        });
    }

    if (this.select_ctrl_no) {
        this.temp_jobnotifications = this.temp_jobnotifications.filter(data => {
          if (this.select_ctrl_no && data.job_control_no) {
            return data.job_control_no.toLowerCase().indexOf(this.select_ctrl_no.toLowerCase()) !== -1 || !this.select_ctrl_no.toLowerCase();
          } else {
            return data.job_control_no;
          }
        });
    }

    if (this.select_activity) {
      this.temp_jobnotifications = this.temp_jobnotifications.filter(data => {
        if (this.select_activity == 'All') {
          return data;
        } else {
          if (this.select_activity == 'No Activity Type') {
            return data.activity_name == null || data.activity_name == ' ';
          } else {
            if (this.select_activity && data.activity_name) {
              return data.activity_name.toLowerCase().indexOf(this.select_activity.toLowerCase()) !== -1 || !this.select_activity.toLowerCase();
            } else {
              return data.activity_name;
            }
          }
        };
      });
    }

    if (this.select_details) {
      this.temp_jobnotifications = this.temp_jobnotifications.filter(data => {
        if (this.select_details && data.text) {
          return data.text.toLowerCase().indexOf(this.select_details.toLowerCase()) !== -1 || !this.select_details.toLowerCase();
        } else {
          return data.text;
        }
      });
    }
  
    this.jobnotifications = this.temp_jobnotifications;
    if(this.temp_jobnotifications.length){
      this.count = this.temp_jobnotifications.length;
    }else{
      this.count = 0;
    }
  }

  public resetFilters() {
    this.select_category = 'All';
    this.select_driver = '';
    this.select_ctrl_no = '';
    this.select_activity = 'All';
    this.start_date = null;
    this.end_date = null;
    this.select_details = '';

    this.jobnotifications = this.full_rows_jnotifications;
    this.count = this.jobnotifications.length;
    
    this.isFilterEmpty = true;
    this.setFilter = true;

  }

  public removeFilter() {
    this.setFilter = true;
    this.frmDate.reset();
    this.start_date = null;
    this.end_date = null;
    this.updateFilter();
  }

  public start_date :any;
  public end_date :any;

  onSubmitDate(event){
    this.setFilter = false;

    this.start_date = this.frmDate.get('start_date').value;
    this.end_date = this.frmDate.get('end_date').value;
  
    this.updateFilter();
    this.modalRef.close();

  }

  
  public openModal(modalContent) {
    this.modalRef = this.modalService.open(modalContent, { container: '.app', backdrop: 'static' });

    this.modalRef.result.then((result) => {
      this.frmDate.reset();
    }, (reason) => {
      this.frmDate.reset();
    });
  }

  
  public closeModal() {
    this.modalRef.close();
  }

  isEnabled(name){
		let is_enabled = false;
		is_enabled = this.svc_components.isComponentEnabled(name);
		return is_enabled
	}

}